<template>
  <!-- the phone version of PropCell: one big number, a bar for our chance, the tile coloured by value -->
  <div class="prop-tile rounded-md px-2 pt-1.5 pb-2 flex flex-col gap-1 min-w-0" :class="toneClass" :title="price && !locked ? title : null">
    <div class="flex items-center justify-between gap-1 min-w-0">
      <span class="text-[10px] uppercase tracking-wide truncate opacity-80">{{ label }}</span>
      <AddPill v-if="price" class="flex-none" :selection="selection" />
    </div>
    <span class="text-[15px] leading-none font-semibold tabular-nums" :class="{ 'blur-sm select-none': locked && price }">{{ main }}</span>
    <span class="block h-1 rounded-full bg-black/10 overflow-hidden" aria-hidden="true">
      <span class="block h-full rounded-full meter" :style="{ width: (price && !locked ? Math.round(price.p) : 0) + '%' }"></span>
    </span>
  </div>
</template>

<script>
import PropCell from "./PropCell.vue";

export default {
  name: "PropTile",
  extends: PropCell,
  props: {
    label: { type: String, required: true },
  },
  computed: {
    tone() {
      if (!this.price || this.locked) return "none";
      if (this.edge === null) return "neutral";
      if (this.edge >= 0.05) return "value";
      if (this.edge <= -0.05) return "poor";
      return "neutral";
    },
    toneClass() {
      return `tone-${this.tone}`;
    },
    main() {
      if (!this.price) return "–";
      if (this.locked) return "??";
      if (this.view === "odds") return this.price.odds ? this.format(this.price.odds) : this.format(100 / this.price.p);
      if (this.view === "value") return this.edge === null ? "–" : this.formatEdge(this.edge * 100);
      return `${Math.round(this.price.p)}%`;
    },
  },
};
</script>

<style scoped>
.tone-value { background: #dcfce7; color: #166534; }
.tone-value .meter { background: #22c55e; }
.tone-poor { background: #fdeeee; color: #9f1239; }
.tone-poor .meter { background: #f87171; }
.tone-neutral { background: #f3f4f6; color: #1f2937; }
.tone-neutral .meter { background: #9ca3af; }
.tone-none { background: #f9fafb; color: #9ca3af; }
html.dark .tone-value { background: rgba(34, 197, 94, 0.18); color: #86efac; }
html.dark .tone-poor { background: rgba(248, 113, 113, 0.16); color: #fca5a5; }
html.dark .tone-neutral { background: rgba(255, 255, 255, 0.06); color: #e5e7eb; }
html.dark .tone-none { background: rgba(255, 255, 255, 0.03); color: #6b7280; }
</style>
